export const skeletonRowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const skeletonBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  flex: 1,
  minWidth: 0,
};

export const skeletonMetaStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
